import script from "./EmployeeMail.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeMail.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__